module.exports = __webpack_public_path__ + "images/feature/20190318-filter-2d0b0aafd1a88f57134667adcb17b563.png";